(() => {
  const initializeSection = (root) => {
    if (!root || root.dataset.componentCardsReady === 'true') return;

    const sectionId = root.dataset.sectionId;
    const variantMap = JSON.parse(root.querySelector('[data-essential-variant-map]')?.textContent || '[]');
    const componentMap = JSON.parse(root.querySelector('[data-essential-component-map]')?.textContent || '{}');
    const variantInput = root.querySelector('input[name="id"]');
    if (!variantInput) return;

    const updatePadAvailability = () => {
      const optionName = root.dataset.padOptionName;
      const group = Array.from(root.querySelectorAll('.product-form__input')).find((candidate) => {
        const label = candidate.querySelector('legend, label');
        return label?.textContent.trim().startsWith(optionName);
      });
      if (!group) return;

      const stockStatus = root.dataset.stockStatus || 'Sold out';
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        const component = (componentMap.pad || []).find((item) => item.option === input.value);
        const unavailable = Boolean(component && !component.available) || input.disabled || input.classList.contains('disabled');
        const label = input.nextElementSibling;
        input.toggleAttribute('data-melo-unavailable', unavailable);
        if (unavailable) input.setAttribute('aria-label', `${input.value} — ${stockStatus}`);
        else input.removeAttribute('aria-label');
        label?.toggleAttribute('data-melo-unavailable', unavailable);
      });

      group.querySelectorAll('select option').forEach((option) => {
        const component = (componentMap.pad || []).find((item) => item.option === option.value);
        const unavailable = Boolean(component && !component.available) || option.disabled;
        const originalLabel = option.dataset.meloOriginalLabel || option.textContent;
        const cleanLabel = originalLabel
          .replace(/\s*(?:-|—|–|:)\s*(?:sold out|out of stock|unavailable|tidak tersedia|stok habis|habis stok)\s*$/i, '')
          .trim();
        option.dataset.meloOriginalLabel = cleanLabel;
        option.toggleAttribute('data-melo-unavailable', unavailable);
        option.hidden = false;
        option.textContent = cleanLabel;
      });
    };

    const updateComponentLinks = (variantId = variantInput.value) => {
      const selected = variantMap.find((variant) => String(variant.id) === String(variantId));
      if (!selected) return;

      Object.entries({ buds: selected.buds, mouse: selected.mouse, pad: selected.pad }).forEach(([kind, option]) => {
        const component = (componentMap[kind] || []).find((item) => item.option === option);
        const card = root.querySelector(`[data-essential-component="${kind}"]`);
        if (!component || !card) return;

        const url = new URL(component.url, window.location.origin);
        url.searchParams.set('variant', component.variantId);
        card.href = url.toString();
        const variantLabel = card.querySelector('[data-component-variant]');
        if (variantLabel) variantLabel.textContent = component.option.replace(/^Melo Buds |^Mousepad |^Deskmat /, '');
      });
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"]')) requestAnimationFrame(updateComponentLinks);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== String(sectionId)) return;
        if (!root.isConnected) {
          unsubscribeVariantChange();
          return;
        }
        updatePadAvailability();
        updateComponentLinks(data.variant?.id);
      });
    }

    root.dataset.componentCardsReady = 'true';
    updatePadAvailability();
    updateComponentLinks();
  };

  const initialize = () => {
    document.querySelectorAll('.noir-melo-essential-bundle').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('.noir-melo-essential-bundle').forEach(initializeSection);
  });
})();
